/**
 * CareRequestStatusService
 * Service for managing care request statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care request status CRUD operations
 */
export class CareRequestStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareRequestStatusService.DEFAULT_SERVICE_PATH,
            basePath: CareRequestStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareRequestStatusService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareRequestStatusService.BASE_PATH = 'api/care-request-statuses';
//# sourceMappingURL=CareRequestStatusService.js.map